module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Light.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Light.woff2
// module id = 77
// module chunks = 8